export enum DocumentType {
  RUT = 1,
  OTHER = 2,
}
